document.addEventListener("DOMContentLoaded", function() {
  const collectionBgEls = document.querySelectorAll('.collection-bg');

  // タイマー管理用
  const timerMap = new WeakMap();
  // 表示状態管理用
  const inViewMap = new WeakMap();

  // 各.collection-bgについてin-view判定し状態を切り替える
  function updateInViewAttributes() {
    collectionBgEls.forEach((el, idx) => {
      // すでにin-viewした場合スキップ
      if (el.hasAttribute('data-in-viewed')) return;

      const rect = el.getBoundingClientRect();
      const elHeight = rect.height;
      const winHeight = (window.innerHeight || document.documentElement.clientHeight);

      // 表示範囲計算
      const visibleTop = Math.max(rect.top, 0);
      const visibleBottom = Math.min(rect.bottom, winHeight);
      const visibleHeight = visibleBottom - visibleTop;

      // 表示割合計算
      const percentVisible = Math.max(0, Math.min(visibleHeight / elHeight, 1));

      // 20%以上表示されているか
      const isInView = (
        rect.bottom > 0 &&
        rect.top < winHeight &&
        visibleHeight > 0 &&
        percentVisible >= 0.2
      );

      const wasInView = inViewMap.get(el) || false;

      if (isInView) {
        if (!wasInView && !el.hasAttribute('data-in-view')) {
          inViewMap.set(el, true);
          // タイマーが既にあればクリア
          if (timerMap.has(el)) {
            clearTimeout(timerMap.get(el));
          }
          const timer = setTimeout(() => {
            el.setAttribute('data-in-viewed', 'true');
            el.setAttribute('data-in-view', 'true');
            updateStyles();
          }, 300);
          timerMap.set(el, timer);
        }
      } else {
        inViewMap.set(el, false);
        // タイマー解除
        if (timerMap.has(el)) {
          clearTimeout(timerMap.get(el));
          timerMap.delete(el);
        }
      }
    });
  }

  // in-viewedな.collection-bg一つずつafterをスタイル
  function updateStyles() {
    // 一度全部消して再構成（重複防止）
    let styleText = '';
    collectionBgEls.forEach((el, idx) => {
      if (el.hasAttribute('data-in-viewed')) {
        // 各要素に一意なdata-id(class名やindex)を付与してターゲット
        let identifier = el.getAttribute('data-uniq-id');
        if (!identifier) {
          identifier = 'collection-bg-uniq-' + idx;
          el.setAttribute('data-uniq-id', identifier);
        }
        styleText += `
          .collection-bg[data-uniq-id="${identifier}"]::before {
            transform: translateX(-50%) rotate(0deg) !important;
          }
        `;
      }
    });

    // グローバルに残らないように単一styleノード利用
    let styleTag = document.getElementById('collection-bg-dynamic-style');
    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = 'collection-bg-dynamic-style';
      document.head.appendChild(styleTag);
    }
    styleTag.textContent = styleText;
  }

  function sync() {
    updateInViewAttributes();
    // updateStyles はupdateInViewAttributes内で個別トリガー
  }

  window.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  sync();
});

// conceptBセクションのスクロール監視
document.addEventListener("DOMContentLoaded", function() {
  const conceptBSection = document.querySelector('.conceptB');
  
  if (!conceptBSection) return;
  
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 1 // 70%以上表示されたら
  };
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // メール画像を切り替え
        const mailContainer = entry.target.querySelector('.conceptB__mail');
        if (mailContainer) {
          const images = mailContainer.querySelectorAll('img');
          
          images.forEach(img => {
            if (img.classList.contains('active_mail')) {
              img.classList.remove('active_mail');
            } else {
              img.classList.add('active_mail');
            }
          });
        }
        
        // 画像切り替え後0.5秒待ってからconceptB__contentをフェードイン
        const content = entry.target.querySelector('.conceptB__content');
        if (content) {
          setTimeout(() => {
            content.classList.add('active');
          }, 1200);
        }
        
        // 一度実行したら監視を解除
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);
  
  observer.observe(conceptBSection);
});

// collection-custom grid__item のアニメーション
document.addEventListener("DOMContentLoaded", function() {
  const gridItems = document.querySelectorAll('.collection-custom .grid__item');
  
  if (gridItems.length === 0) return;
  
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1 // 10%以上表示されたら
  };
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // 要素のインデックスを取得してディレイを計算
        const index = Array.from(gridItems).indexOf(entry.target);
        const delay = index * 150; // 150msずつ遅らせる
        
        setTimeout(() => {
          entry.target.classList.add('pop-in');
        }, delay);
        
        // 一度アニメーションしたら監視を解除
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);
  
  // 各grid__itemを監視
  gridItems.forEach(item => {
    observer.observe(item);
  });
});